import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function scrollImmediately(target?: HTMLElement | null) {
  // The project's DOM types predate "instant", which overrides CSS smooth scrolling.
  const behavior = "instant" as ScrollBehavior;
  if (target) target.scrollIntoView({ block: "start", behavior });
  else window.scrollTo({ top: 0, left: 0, behavior });
}

export default function ScrollToTop() {
  const { pathname, search, hash, key } = useLocation();

  useLayoutEffect(() => {
    const previousRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => { window.history.scrollRestoration = previousRestoration; };
  }, []);

  useLayoutEffect(() => {
    scrollImmediately();
    if (!hash) return;

    let id = hash.slice(1);
    try { id = decodeURIComponent(id); } catch { /* Use the literal ID for malformed escapes. */ }
    const scrollToSection = () => {
      const target = document.getElementById(id);
      if (!target) return false;
      scrollImmediately(target);
      return true;
    };
    if (scrollToSection()) return;

    // Detail-page sections appear after their API response arrives.
    const observer = new MutationObserver(() => {
      if (scrollToSection()) observer.disconnect();
    });
    observer.observe(document.getElementById("root") || document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [pathname, search, hash, key]);

  return null;
}
